<template>
  <div v-if="activity">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    $route: {
      handler: function(to, from) {
        window.scrollTo(0, 0)
      },
      deep: true,
    },
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    activity() {
      return this.$store.getters.activity
    },
    checkin() {
      return this.$store.getters.checkin
    },
  },
  created() {
    this.jssdk()
  },
  methods: {
    jssdk() {
      let wx = window.wx,
        url = location.href.replace(location.hash, '')

      this.$api.wechat.jssdk({ url: url }).then((config) => {
        wx.config({
          //debug: true,
          appId: config.appId,
          timestamp: config.timestamp,
          nonceStr: config.nonceStr,
          signature: config.signature,
          jsApiList: ['hideAllNonBaseMenuItem', 'hideOptionMenu', 'hideMenuItems', 'updateAppMessageShareData', 'updateTimelineShareData'],
        })
      })

      wx.error((response) => {
        console.log(response)
      })
    },
  },
}
</script>

<style>
:root {
  --main-color: #567efa;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
p,
span,
img,
button,
form,
label,
input,
select,
option,
textarea,
b,
strong,
i,
em {
  margin: 0;
  padding: 0;
}
h1,
h2,
h3,
h4,
h5,
h6,
b,
strong {
  font-weight: bold;
}
i,
em {
  font-style: normal;
}
li {
  list-style: none;
}
img {
  border: none;
}
a {
  color: #000;
  text-decoration: none;
}
input,
button {
  outline: none;
  background: none;
  border: 0;
  border-radius: 0;
  -webkit-appearance: none;
}
input::placeholder {
  color: #999;
}
input::-webkit-input-placeholder {
  color: #999;
}
textarea {
  resize: none;
}

body {
  font-size: 3vw;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}
.van-dialog__message img {
  display: block;
  margin: 0 auto;
}
</style>
